import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import './Message.css';

class Message extends Component {
  	render() {
		const content = this.props.message.content;
		const type = this.props.message.type;
		const id = this.props.id;
		return (
			  <div
			  	id={id}
			  	className={"showtix-message showtix-message__" + type + (this.props.message.content !== "" || this.props.message.type === "loading" ? ' is-active' : '')}>
	  			<div className="showtix-padder">
					{this.props.message.title !== "" &&
						<h3 className="showtix-message__title">{this.props.message.title}</h3>
					}
					<p>{ReactHtmlParser(content)}</p>
					{ this.props.message.type === 'loading' && 
						<div className="showtix-loader">Loading...</div>
					}
				</div>	
		  	</div>
		);
  	}
}

Message.propTypes = {
	id: PropTypes.string,
	message: PropTypes.shape({
        title: PropTypes.string,
		content: PropTypes.string,
		type: PropTypes.string // error, success, loading
    })
};

export default Message;


// WEBPACK FOOTER //
// ./src/components/Common/Message/Message.js